import { render } from "./FieldWithHistory.vue?vue&type=template&id=6ee80b5d"
import script from "./FieldWithHistory.vue?vue&type=script&lang=js"
export * from "./FieldWithHistory.vue?vue&type=script&lang=js"

import "./FieldWithHistory.vue?vue&type=style&index=0&id=6ee80b5d&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__